<template><markdown-wrapper><h1 id="multiselect">MultiSelect <a class="header-anchor" href="#multiselect">&#128279;</a></h1>
<p><ins class="adsbygoogle"
     style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-4714899946256166"
     data-ad-slot="4603582855"></ins></p>
<h2 id="example">Example <a class="header-anchor" href="#example">&#128279;</a></h2>
<p>Use <code v-pre>v-model</code> to bind selected values, and <code v-pre>options</code> as select options.</p>
<multi-select-example ref="multi-select-example"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-example.vue --&gt;</span>
</code></pre>
<h2 id="multiple-limit">Multiple Limit <a class="header-anchor" href="#multiple-limit">&#128279;</a></h2>
<p>Use <code v-pre>limit</code> to restrict the maximum number of options user can select, no limit when set to <code v-pre>0</code>.</p>
<multi-select-limit ref="multi-select-limit"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">:limit</span>=<span class="hljs-string">&quot;3&quot;</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-limit.vue --&gt;</span>
</code></pre>
<h2 id="optional-sizes">Optional Sizes <a class="header-anchor" href="#optional-sizes">&#128279;</a></h2>
<p>Optional sizes <code v-pre>sm</code> and <code v-pre>lg</code> are supported. You can also add <code v-pre>block</code> prop to quickly apply <code v-pre>width: 100%</code> style to the component.</p>
<multi-select-sizes ref="multi-select-sizes"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">section</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">size</span>=<span class="hljs-string">&quot;sm&quot;</span>/&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span>/&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">size</span>=<span class="hljs-string">&quot;lg&quot;</span>/&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">size</span>=<span class="hljs-string">&quot;lg&quot;</span> <span class="hljs-attr">block</span>/&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">section</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-sizes.vue --&gt;</span>
</code></pre>
<h2 id="disabled-options">Disabled options <a class="header-anchor" href="#disabled-options">&#128279;</a></h2>
<p>Add <code v-pre>disabled: true</code> to an option to disable it.</p>
<multi-select-disabled-options ref="multi-select-disabled-options"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>, <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>, <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-disabled-options.vue --&gt;</span>
</code></pre>
<h2 id="disabled-select">Disabled select <a class="header-anchor" href="#disabled-select">&#128279;</a></h2>
<multi-select-disabled-select ref="multi-select-disabled-select"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">disabled</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-disabled-select.vue --&gt;</span>
</code></pre>
<h2 id="collapse-selected">Collapse selected <a class="header-anchor" href="#collapse-selected">&#128279;</a></h2>
<p>Collapse multiple selected items into a text by using <code v-pre>collapse-selected</code> prop.</p>
<multi-select-collapse-selected ref="multi-select-collapse-selected"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">collapse-selected</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-collapse-selected.vue --&gt;</span>
</code></pre>
<h2 id="option-groups">Option groups <a class="header-anchor" href="#option-groups">&#128279;</a></h2>
<p>If you need grouped options, simply add <code v-pre>group</code> (String) as the name to them.</p>
<multi-select-option-groups ref="multi-select-option-groups"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Apple&#x27;</span>, <span class="hljs-attr">group</span>: <span class="hljs-string">&#x27;Fruit&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Banana&#x27;</span>, <span class="hljs-attr">group</span>: <span class="hljs-string">&#x27;Fruit&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Orange&#x27;</span>, <span class="hljs-attr">group</span>: <span class="hljs-string">&#x27;Fruit&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Red&#x27;</span>, <span class="hljs-attr">group</span>: <span class="hljs-string">&#x27;Color&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Green&#x27;</span>, <span class="hljs-attr">group</span>: <span class="hljs-string">&#x27;Color&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-option-groups.vue --&gt;</span>
</code></pre>
<h2 id="filterable">Filterable <a class="header-anchor" href="#filterable">&#128279;</a></h2>
<p>Add <code v-pre>filterable</code> to append filter input before options.</p>
<p>By default, options are filtered by item value and label (case ignored), use a custom <code v-pre>filter-function</code> to override it if needed.</p>
<multi-select-filterable ref="multi-select-filterable"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">multi-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;selected&quot;</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">&quot;options&quot;</span> <span class="hljs-attr">filterable</span>/&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">selected</span>: [],
        <span class="hljs-attr">options</span>: [
          {<span class="hljs-attr">value</span>: <span class="hljs-number">1</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option1&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option2&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">3</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option3&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">4</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option4&#x27;</span>},
          {<span class="hljs-attr">value</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">label</span>:<span class="hljs-string">&#x27;Option5&#x27;</span>}
        ]
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- multi-select-filterable.vue --&gt;</span>
</code></pre>
<h1 id="api-reference">API Reference <a class="header-anchor" href="#api-reference">&#128279;</a></h1>
<h2 id="multiselect-1"><a href="https://github.com/wxsms/uiv/blob/0.x/src/components/select/MultiSelect.vue">MultiSelect</a> <a class="header-anchor" href="#multiselect-1">&#128279;</a></h2>
<h3 id="props">Props <a class="header-anchor" href="#props">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Type</th>
<th>Default</th>
<th>Required</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>v-model</code></td>
<td>Array</td>
<td></td>
<td>✔</td>
<td>The selected values.</td>
</tr>
<tr>
<td><code v-pre>options</code></td>
<td>Array</td>
<td></td>
<td>✔</td>
<td>The select options.</td>
</tr>
<tr>
<td><code v-pre>label-key</code></td>
<td>String</td>
<td>label</td>
<td></td>
<td>Identity key name for label.</td>
</tr>
<tr>
<td><code v-pre>value-key</code></td>
<td>String</td>
<td>value</td>
<td></td>
<td>Identity key name for value.</td>
</tr>
<tr>
<td><code v-pre>limit</code></td>
<td>Boolean</td>
<td>0</td>
<td></td>
<td>Maximum number of options user can select, no limit when set to <code v-pre>0</code>.</td>
</tr>
<tr>
<td><code v-pre>size</code></td>
<td>String</td>
<td></td>
<td></td>
<td>Optional sizes, supported: <code v-pre>sm</code> / <code v-pre>lg</code>.</td>
</tr>
<tr>
<td><code v-pre>block</code></td>
<td>Boolean</td>
<td>false</td>
<td></td>
<td>Apply block level style.</td>
</tr>
<tr>
<td><code v-pre>placeholder</code></td>
<td>String</td>
<td>Select...</td>
<td></td>
<td>The default text displayed when no options are selected.</td>
</tr>
<tr>
<td><code v-pre>split</code></td>
<td>String</td>
<td>,</td>
<td></td>
<td>The options display spliter.</td>
</tr>
<tr>
<td><code v-pre>filterable</code></td>
<td>Boolean</td>
<td>false</td>
<td></td>
<td>Append filter input before options (default is filter by item value and label, case ignored).</td>
</tr>
<tr>
<td><code v-pre>filter-placeholder</code></td>
<td>String</td>
<td>Search...</td>
<td></td>
<td>The default text displayed in filter input.</td>
</tr>
<tr>
<td><code v-pre>filter-auto-focus</code></td>
<td>Boolean</td>
<td>true</td>
<td></td>
<td>Auto focus on filter input.</td>
</tr>
<tr>
<td><code v-pre>filter-function</code></td>
<td>Function</td>
<td></td>
<td></td>
<td>Custom filter function, with one param as input string, and returns the filtered array.</td>
</tr>
<tr>
<td><code v-pre>disabled</code></td>
<td>Boolean</td>
<td>false</td>
<td></td>
<td>Disable the select component.</td>
</tr>
<tr>
<td><code v-pre>collapse-selected</code></td>
<td>Boolean</td>
<td>false</td>
<td></td>
<td>Collapse multiple selected items into a text.</td>
</tr>
<tr>
<td><code v-pre>append-to-body</code></td>
<td>Boolean</td>
<td>false</td>
<td></td>
<td>Append the dropdown to <code v-pre>body</code>.</td>
</tr>
<tr>
<td><code v-pre>selected-icon</code></td>
<td>String</td>
<td>glyphicon glyphicon-ok</td>
<td></td>
<td>Icon displayed in option while selected.</td>
</tr>
<tr>
<td><code v-pre>item-selected-class</code></td>
<td>String</td>
<td></td>
<td></td>
<td>(0.24.0+) The class applied to the selected list item.</td>
</tr>
</tbody>
</table></div><h3 id="events">Events <a class="header-anchor" href="#events">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Params</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>change</code></td>
<td>value</td>
<td>Triggers when the selected value changes.</td>
</tr>
<tr>
<td><code v-pre>visible-change</code></td>
<td>the visible status (true / false)</td>
<td>Triggers when the dropdown toggles.</td>
</tr>
<tr>
<td><code v-pre>limit-exceed</code></td>
<td></td>
<td>Triggers when the selected value length exceeded limit.</td>
</tr>
<tr>
<td><code v-pre>focus</code></td>
<td>event</td>
<td>Triggers when input focuses.</td>
</tr>
<tr>
<td><code v-pre>blur</code></td>
<td>event</td>
<td>Triggers when input blurs.</td>
</tr>
</tbody>
</table></div><h3 id="slots">Slots <a class="header-anchor" href="#slots">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>option</code></td>
<td>(0.37+) The option scoped slot, with <code v-pre>item</code> prop.</td>
</tr>
</tbody>
</table></div></markdown-wrapper></template><script>
  

  

  

  

  

  

  

  
export default {components:{'multi-select-example':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\"/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  },'multi-select-limit':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\" :limit=\"3\"/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  },'multi-select-sizes':{"template":"<div class=\"markdown-live-example\">\n  <section>\n    <div>\n      <multi-select v-model=\"selected\" :options=\"options\" size=\"sm\"/>\n    </div>\n    <br/>\n    <div>\n      <multi-select v-model=\"selected\" :options=\"options\"/>\n    </div>\n    <br/>\n    <div>\n      <multi-select v-model=\"selected\" :options=\"options\" size=\"lg\"/>\n    </div>\n    <br/>\n    <div>\n      <multi-select v-model=\"selected\" :options=\"options\" size=\"lg\" block/>\n    </div>\n  </section>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  },'multi-select-disabled-options':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\"/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3', disabled: true},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5', disabled: true}
        ]
      }
    }
  },'multi-select-disabled-select':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\" disabled/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  },'multi-select-collapse-selected':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\" collapse-selected/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  },'multi-select-option-groups':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\"/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Apple', group: 'Fruit'},
          {value: 2, label:'Banana', group: 'Fruit'},
          {value: 3, label:'Orange', group: 'Fruit'},
          {value: 4, label:'Red', group: 'Color'},
          {value: 5, label:'Green', group: 'Color'}
        ]
      }
    }
  },'multi-select-filterable':{"template":"<div class=\"markdown-live-example\">\n  <multi-select v-model=\"selected\" :options=\"options\" filterable/>\n</div>",
    data () {
      return {
        selected: [],
        options: [
          {value: 1, label:'Option1'},
          {value: 2, label:'Option2'},
          {value: 3, label:'Option3'},
          {value: 4, label:'Option4'},
          {value: 5, label:'Option5'}
        ]
      }
    }
  }}}</script>